<template>
  <div class="Calendar">
    <div class="Calendar_top">
      <div class="Arrow__btn Arrow__btn_left" @click="$emit('prevMonth')" />
      <div class="Calendar_title">
        {{ calendarTitle() }}
        <span> {{ calendarMonth() }}</span>
      </div>
      <div class="Arrow__btn Arrow__btn_right" @click="$emit('nextMonth')" />
    </div>
    <div>
      <table class="Calendar__table">
        <thead class="Calendar__thead">
          <tr>
            <th v-for="dayName of dayNames" :key="dayName" class="Calendar__cell Calendar__cell_day">
              <div>{{ dayName }}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(week,weekIndex) of datesOfWeekCalendar" :key="weekIndex">
            <td
              v-for="date of week"
              :key="date"
              :class="`Calendar__cell Calendar__date ${getStatusDate(date)}`"
              @click="$emit('selectDate',date)"
            >
              <div class="Calendar__date_num">
                <span>{{ showDate(date) }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

import moment from 'moment'
import LogService from '@/services/logService'
import melonLogService from '@/services/melonLogService'
import zoomLogService from '@/services/zoomLogService'

export default {
  name: 'Calendar',
  props: {
    datesHaveLog: {
      type: Array,
      default: () => []
    },
    selectMonth: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dayNames: ['mon.', 'tue.', 'wed.', 'thu.', 'fri.', 'sat.', 'sun.'],
      datesOfMonth: [],
      datesOfWeekCalendar: [],
      allLogs: null,
      allMelons: null,
      allZooms: null
    }
  },
  computed: {},

  watch: {
    selectMonth: {
      immediate: true,
      handler() {
        this.calcCalendar()
      }
    }
  },
  methods: {
    dateHasLog(date) {
      return this.datesHaveLog.indexOf(date) !== -1
    },
    showDate(date) {
      return moment(date).format('DD')
    },
    getStatusDate(date) {
      let classDate = ''
      const dateDiffSelectMonth = moment(date).diff(this.selectMonth, 'months', true)
      const dateDiffMoment = moment(date).diff(moment())
      if (dateDiffMoment > 0) {
        classDate += ' Calendar__future'
      }
      if (dateDiffSelectMonth < -1) {
        classDate += ' Calendar__past Calendar__hidden'
      } else if (dateDiffSelectMonth > 0) {
        classDate += ' Calendar__future Calendar__hidden'
      }
      if (this.dateHasLog(date)) {
        classDate += ' Calendar__date_log'
      }
      if (!classDate) {
        if (this.allLogs.includes(date)) {
          classDate += ' Calendar__date_log'
        } else {
          if (this.allZooms.includes(date) || this.allMelons.includes(date)) {
            classDate += ' Calendar__without_log'
          }
        }
      }
      return classDate
    },
    async calcCalendar() {
      this.datesOfMonth = this.getDaysOfMonth()
      const datesOfCalendar = [].concat(this.calcDatesOfLastMonth(), this.datesOfMonth, this.calcDatesOfNextMonth())
      const queryParams = {
        params: {
          first: datesOfCalendar[0],
          last: datesOfCalendar[datesOfCalendar.length - 1 ]
        }
      }
      this.$store.dispatch('loading/updateLoading', true)
      const logs = await LogService.index(queryParams)
      this.allLogs = logs.data.map(a => moment(a.created_at).format('YYYY-MM-DD'))
      const zooms = await zoomLogService.index(queryParams)
      this.allZooms = zooms.data.map(a => a.date)
      const melons = await melonLogService.index(queryParams)
      this.allMelons = melons.data.map(a => a.date)
      this.$emit('allLogOfUser', logs.data)
      this.datesOfWeekCalendar = this.calcDatesOfWeekCalendar(datesOfCalendar)
      this.$store.dispatch('loading/updateLoading', false)
    },
    calcDatesOfWeekCalendar(datesOfCalendar) {
      const result = []
      while (datesOfCalendar.length) {
        result.push(datesOfCalendar.splice(0, 7))
      }
      return result
    },
    calcDatesOfLastMonth() {
      const firstDay = moment(this.datesOfMonth[0])
      const amountDays = firstDay.isoWeekday() - 1
      const listDays = []
      for (let i = 0; i < amountDays; i++) {
        const day = firstDay.subtract(1, 'days').format('YYYY-MM-DD')
        listDays.push(day)
      }
      return listDays.reverse()
    },
    calcDatesOfNextMonth() {
      const lastDay = moment(this.datesOfMonth[this.datesOfMonth.length - 1])
      const amountDays = 7 - lastDay.isoWeekday()
      const listDays = []
      for (let i = 0; i < amountDays; i++) {
        const day = lastDay.add(1, 'days').format('YYYY-MM-DD')
        listDays.push(day)
      }
      return listDays
    },
    getDaysOfMonth() {
      const daysInMonth = this.selectMonth.daysInMonth()
      const listDays = []
      for (let i = 1; i <= daysInMonth; i++) {
        listDays.push(this.selectMonth.date(i).format('YYYY-MM-DD'))
      }
      return listDays
    },
    calendarTitle() {
      return this.selectMonth.format('YYYY')
    },
    calendarMonth() {
      return this.selectMonth.format('MMMM')
    }
  }
}
</script>
